import React from "react";
import BaseList from "../Common/BaseList";
import { Checkbox } from "antd";

class CustomerRegProductList extends BaseList {
  constructor(props) {
    super();
    this.state = {
      rowSeletion: [],
    };

    this.columns = [
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item #
          </div>
        ),
        dataIndex: "productCode",
        className: "list-data",
        key: "productCode",
        id: "22",
        align: "left",
        width: "100px",
        sorter: true,

        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Photos
          </div>
        ),
        dataIndex: "image",
        className: "list-data",
        id: "33",
        key: "image",
        align: "left",
        width: "100px",
        render: (data) => (
          <img
            src={data}
            style={{ width: "75px", height: "75px", borderRadius: "10px" }}
            alt="icon"
          />
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Name
          </div>
        ),
        dataIndex: "productName",
        className: "list-data",
        id: "44",
        key: "productName",
        align: "left",
        width: "200px",
        sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Description
          </div>
        ),
        dataIndex: "description",
        className: "list-data",
        key: "description",
        align: "left",
        width: "450px",
        sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
    ];
    if (props.Select) {
      this.columns = [
        {
          title: (
            <div className="list-head" style={{ color: "grey" }}>
              Select
            </div>
          ),
          dataIndex: "id",
          key: "id",
          id: "11",
          render: (row) => (
            <Checkbox
              id="rowcheck{products.id}"
              className="custom_checkbox"
              onChange={(event) => props.onItemCheck(event, row)}
            ></Checkbox>
          ),
        },
        ...this.columns,
      ];
    }
  }
}

export default CustomerRegProductList;
